<!-- <div class="sales-dashboard"> -->
    <!-- <div class="dashboard-header">
      <h2>Sales Performance Dashboard</h2>
      <div class="toggle-container" *ngIf="viewOption === 'toggle'">
        <label class="toggle-label">
          <nb-toggle 
            [(ngModel)]="showCumulative" 
            (ngModelChange)="onToggleChange()">
          </nb-toggle>
          <span class="toggle-text">{{ showCumulative ? 'Cumulative View' : 'Period View' }}</span>
        </label>
      </div>
      <div class="mode-indicator" *ngIf="viewOption !== 'toggle'">
        <span class="indicator-text">{{ getModeLabel() }}</span>
      </div>
    </div> -->
    
    <div class="cards-grid">
      <!-- Week Card -->
      <div class="flip-card" 
           (mouseenter)="onCardHover('week', true)" 
           (mouseleave)="onCardHover('week', false)">
        <div class="flip-card-inner" [class.flipped]="cardStates.week">
          <!-- Front - Chart -->
          <div class="flip-card-front">
            <div class="card-header">
              <nb-icon icon="calendar-outline" class="card-icon"></nb-icon>
              <h3>Week Sales</h3>
              <span class="period-label">{{ getCurrentWeekRange() }}</span>
            </div>
            <div class="chart-container">
              <div id="weekChart" class="chart"></div>
            </div>
            <div class="hover-hint">Hover for breakdown</div>
          </div>
          <!-- Back - Breakdown -->
          <div class="flip-card-back">
            <div class="breakdown-content">
              <h3>Weekly Breakdown</h3>
              <div class="total-display">
                <span class="total-label">Total Sales</span>
                <span class="total-amount">R{{ getWeekTotal().toLocaleString() }}</span>
              </div>
              <div class="breakdown-list">
                <div *ngFor="let item of generateWeekData()" class="breakdown-item">
                  <span class="breakdown-date">{{ item.date }}</span>
                  <span class="breakdown-amount">R{{ item.sales.toLocaleString() }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Month Card -->
      <div class="flip-card" 
           (mouseenter)="onCardHover('month', true)" 
           (mouseleave)="onCardHover('month', false)">
        <div class="flip-card-inner" [class.flipped]="cardStates.month">
          <!-- Front - Chart -->
          <div class="flip-card-front">
            <div class="card-header">
              <nb-icon icon="trending-up-outline" class="card-icon"></nb-icon>
              <h3>Month Sales</h3>
              <span class="period-label">{{ getCurrentMonthName() }}</span>
            </div>
            <div class="chart-container">
              <div id="monthChart" class="chart"></div>
            </div>
            <div class="hover-hint">Hover for breakdown</div>
          </div>
          <!-- Back - Breakdown -->
          <div class="flip-card-back">
            <div class="breakdown-content">
              <h3>Monthly Summary</h3>
              <div class="total-display">
                <span class="total-label">Total Sales</span>
                <span class="total-amount">R{{ getMonthTotal().toLocaleString() }}</span>
              </div>
              <div class="stats-grid">
                <div class="stat-item">
                  <span class="stat-label">Days</span>
                  <span class="stat-value">{{ generateMonthData().length }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Average</span>
                  <span class="stat-value">R{{ getMonthAverage().toLocaleString() }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Best Day</span>
                  <span class="stat-value">R{{ getBestDay('month').toLocaleString() }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Growth</span>
                  <span class="stat-value positive">+12.5%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Quarter Card -->
      <div class="flip-card" 
           (mouseenter)="onCardHover('quarter', true)" 
           (mouseleave)="onCardHover('quarter', false)">
        <div class="flip-card-inner" [class.flipped]="cardStates.quarter">
          <!-- Front - Chart -->
          <div class="flip-card-front">
            <div class="card-header">
              <nb-icon icon="pie-chart-outline" class="card-icon"></nb-icon>
              <h3>Quarter Sales</h3>
              <span class="period-label">{{ getCurrentQuarterName() }}</span>
            </div>
            <div class="chart-container">
              <div id="quarterChart" class="chart"></div>
            </div>
            <div class="hover-hint">Hover for breakdown</div>
          </div>
          <!-- Back - Breakdown -->
          <div class="flip-card-back">
            <div class="breakdown-content">
              <h3>Quarterly Summary</h3>
              <div class="total-display">
                <span class="total-label">Q{{ getCurrentQuarter() }} Sales</span>
                <span class="total-amount">R{{ getQuarterTotal().toLocaleString() }}</span>
              </div>
              <div class="quarter-breakdown">
                <div *ngFor="let month of getQuarterMonths()" class="month-item">
                  <span class="month-name">{{ month.name }}</span>
                  <span class="month-amount">R{{ month.sales.toLocaleString() }}</span>
                </div>
              </div>
              <div class="quarter-stats">
                <div class="stat-item">
                  <span class="stat-label">vs Last Quarter</span>
                  <span class="stat-value positive">+8.2%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- YTD Card -->
      <div class="flip-card" 
           (mouseenter)="onCardHover('ytd', true)" 
           (mouseleave)="onCardHover('ytd', false)">
        <div class="flip-card-inner" [class.flipped]="cardStates.ytd">
          <!-- Front - Chart -->
          <div class="flip-card-front">
            <div class="card-header">
              <nb-icon icon="bar-chart-outline" class="card-icon"></nb-icon>
              <h3>YTD Sales</h3>
              <span class="period-label">{{ getCurrentYear() }}</span>
            </div>
            <div class="chart-container">
              <div id="ytdChart" class="chart"></div>
            </div>
            <div class="hover-hint">Hover for breakdown</div>
          </div>
          <!-- Back - Breakdown -->
          <div class="flip-card-back">
            <div class="breakdown-content">
              <h3>Year to Date</h3>
              <div class="total-display">
                <span class="total-label">YTD Sales</span>
                <span class="total-amount">R{{ getYTDTotal().toLocaleString() }}</span>
              </div>
              <div class="ytd-stats">
                <div class="stat-item">
                  <span class="stat-label">Months</span>
                  <span class="stat-value">{{ getCurrentMonth() + 1 }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Data Points</span>
                  <span class="stat-value">{{ generateYTDData().length }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Projected Annual</span>
                  <span class="stat-value">R{{ getProjectedAnnual().toLocaleString() }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">vs Last Year</span>
                  <span class="stat-value positive">+15.3%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- </div> -->